import React from 'react';
import { Outlet } from 'react-router-dom';
import { Navbar } from '../navigation/Navbar';
import { Footer } from '../../../features/home/components/Footer';

/**
 * PublicLayout — used for marketing/public-facing pages.
 *
 * Equivalent to Laravel's `layouts.public` Blade template.
 * Provides the floating transparent navbar and footer.
 *
 * Pages using this layout:
 * - Home, About, Contact, Blog, FAQ, Terms, Privacy, Cancellation
 * - Login, Register, Forgot Password
 * - Safari discovery, Trip discovery (public browsing)
 * - Marketplace (public view)
 */
export const PublicLayout: React.FC = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="min-h-screen">
        <Outlet />
        <Footer />
      </main>
    </div>
  );
};
